import React from 'react';
import orderBy from 'lodash/orderBy';

// types
import { AuthenticatedAudience } from 'ducks/merchantDucks/audience/types';

// components
import EmptyMessage from 'components/EmptyMessage';
import ProgressBar from './ProgressBar';
import Tile from './Tile';

interface Props {
  authDevices: Array<AuthenticatedAudience>;
  totalAuthData: number;
  deviceType: DeviceType;
}

export enum DeviceType {
  LOGIN = 'login',
  REGISTRATION = 'registration',
}

const AuthenticationDevice: React.FC<Props> = ({ authDevices, totalAuthData, deviceType }) => {
  return (
    <Tile
      title={`${deviceType} device`}
      tileWidth="100%"
      tileContent={
        totalAuthData && authDevices ? (
          <ProgressBar totalRegistrations={totalAuthData} data={orderBy(authDevices, ['total'], ['desc'])} />
        ) : (
          <EmptyMessage variant="p">There is no available data for this time period.</EmptyMessage>
        )
      }
    />
  );
};

export default AuthenticationDevice;
